import { useMutation } from '@tanstack/react-query';
import { apiPost } from '@/api/client';
import type { AdminAuthSuccess } from '@/api/types';
import { useAuthStore } from '@/store/auth';

interface LoginInput {
  email: string;
  password: string;
}

export function useLogin() {
  const setSession = useAuthStore((s) => s.setSession);
  return useMutation({
    mutationFn: async (input: LoginInput) =>
      apiPost<AdminAuthSuccess, LoginInput>('/auth/login', input),
    onSuccess: (data) => {
      setSession({
        accessToken: data.access_token,
        accessExpiresAt: data.access_expires_at,
        refreshToken: data.refresh_token,
        refreshExpiresAt: data.refresh_expires_at,
        user: data.admin_user,
      });
    },
  });
}

export function useLogout() {
  const clear = useAuthStore((s) => s.clear);
  return useMutation({
    mutationFn: async () => {
      // Fire-and-forget — even if the server is unreachable we still
      // clear local state.
      try {
        await apiPost<void>('/auth/logout');
      } catch {
        // ignore — local state is the source of truth on the client.
      }
    },
    onSettled: () => {
      clear();
    },
  });
}
